import React, { ReactNode } from "react";
import { usePopup } from "../../context/PopupContext";
import { closePopup } from "../../utils/popupUtilities";

interface Props {
    children: ReactNode;
}

export default function PopupContainer({ children }: Props) {

    return (
        <>
            <div id="popupoverlay" onClick={closePopup} className="transition-all hidden w-full h-screen absolute top-0 right-0 bg-black bg-opacity-70 z-0 flex items-center justify-around z-20">
            </div>
            <div id="popupform" className="popupform transition-all hidden absolute rounded w-4/12 absolute-center z-50">
                <div className="absolute right-2 top-1 z-40 cursor-pointer close-form-cross" onClick={closePopup}>X</div>
                <div id="popupcontent" className="w-full h-full relative px-8 py-8 bg-white dark:bg-ngray">
                    {children}
                </div>
            </div>
        </>
    );
}